<template>
  <div
    :class="{ 'popup-action-inline': inlineAction }"
    @click.stop
    @mousedown.stop
    @mouseup.stop
  >
    <v-btn
      style="
        background: var(--oms-primary, #f58220) !important;
        margin-right: 170px;
        color: #ffffff !important;
      "
      class="commentbtn"
      flat
      prepend-icon
      color="white darken-1"
      @click.stop="check()"
      >Change Customer</v-btn
    >

    <v-dialog
      v-model="dialog"
      persistent
      max-width="28rem"
      content-class="oms-job-dialog oms-job-dialog--customer change-customer-dialog"
    >
      <v-card class="oms-job-popup-card oms-job-customer-dialog-card">
        <header class="change-customer-header">
          <h2 class="change-customer-title">Change Customer</h2>
          <v-btn
            icon
            class="change-customer-close"
            title="Close"
            @click="close()"
          >
            <v-icon>close</v-icon>
          </v-btn>
        </header>

        <v-card-text class="comment__form change-customer-body">
          <v-form
            ref="form"
            v-model="valid"
            lazy-validation
            onSubmit="return false;"
          >
            <div class="change-customer-field">
              <label class="change-customer-label">Choose new customer</label>
              <v-autocomplete
                :items="customers"
                item-text="text"
                item-value="value"
                v-model="customerId"
                placeholder="Select a customer"
                hide-selected
                hide-no-data
                outline
                hide-details
                single-line
                class="change-customer-input"
              />
            </div>
            <small class="success" v-show="this.res">{{ this.res }}</small>
            <div class="change-customer-actions">
              <v-btn
                class="change-customer-submit"
                :disabled="processing"
                @click="customerChange"
              >
                Change Customer
              </v-btn>
            </div>
          </v-form>
        </v-card-text>
      </v-card>

      <v-snackbar
        :timeout="6000"
        bottom
        color="red darken-2"
        v-model="x.error"
        class="white--text"
        v-if="x.error"
        >{{ x.error }}</v-snackbar
      >
    </v-dialog>
  </div>
</template>
<script>
import { StorageKeys } from "../../constants/constants";
import { EventBus } from "../../event-bus.js";
import SuccessDialog from "@/components/Common/SuccessDialog";
import ErrorBox from "@/components/Common/ErrorBox";
import vueCustomScrollbar from "vue-custom-scrollbar";
import moment from "moment";
import "vue-custom-scrollbar/dist/vueScrollbar.css";
import { getCommentList, userList, addComment } from "../../constants/api-urls";
import axios from "axios";

const api = "https://hn.algolia.com/api/v1/search_by_date?tags=story";

export default {
  created() {},
  data() {
    return {
      res: "",
      ids: "",
      workingCountry: "",
      opeartionName: "",
      isSelect: "",
      operationId: "",
      dialog: false,
      selected: ["email"],
      toggleClass: false,
      toggle_exclusive: 0,
      assigIdShow: 0,
      subject: null,
      message: "",
      loading: false,
      processing: false,
      commentsListing: [],
      customerId: "",
      valid: true,
      x: {
        error: "",
        message: "",
        loading: false,
        success: false,
        valid: true,
        currentUser: "",
        disableAdd: false,
      },

      items: [],
      AssignmentId: [],

      customers: [],
    };
  },
  components: {
    ErrorBox,
    SuccessDialog,
    vueCustomScrollbar,
  },
  props: {
    id: String,
    inlineAction: Boolean,
  },

  watch: {
    communicateDialog(val) {},
  },
  methods: {
    async check() {
      this.dialog = true;

      if (localStorage.getItem("workingCountries")) {
        let workingCountries = JSON.parse(
          localStorage.getItem("workingCountries")
        );
        workingCountries.forEach((key, index) => {
          if (key.isSelected) {
            this.x.customerCurrency = key.currency;
            this.workingCountry = key.value;
            this.fetchShippers(key.value);
          }
        });
      }
    },
    fetchShippers(val) {
      delete this.axios.defaults.headers.common["token"];
      let token = localStorage.getItem(StorageKeys.SessionKey);
      let config = {
        headers: {
          authorization: `bearer ${token}`,
        },
      };
      this.t = config.headers.authorization;
      let body = { workingCountry: [val], section: "job" };
      this.axios
        .post(`${this.constants.apiUrl}/dmsAdmin/shippers`, body, config)
        .then((response) => {
          const { data = null } = response.data;
          for (var i = 0; i < data.length; i++) {
            data[i].fullName = data[i].name + "(" + data[i].companyName + ")";
          }

          data.forEach((element) => {
            if (element.companyName) {
              this.customers.push({
                text: element.fullName,
                value: element._id,
                companyVatNumber: element.companyVatNumber,
                address: element.address
                  ? element.address.replaceAll("\n", ", ")
                  : "",
                invoicingCity: element.invoicingCity,
                invoicingCountry: element.invoicingCountry,
                selectedIndustry: element.selectedIndustry,
              });
            } else {
              this.customers.push({
                text: element.name,
                value: element._id,
                companyVatNumber: element.companyVatNumber,
                address: element.address
                  ? element.address.replaceAll("\n", ", ")
                  : "",
                invoicingCity: element.invoicingCity,
                invoicingCountry: element.invoicingCountry,
                selectedIndustry: element.selectedIndustry,
              });
            }
          });
        });
    },
    async customerChange() {
      console.log("tryyyy", this.customerId);
      if (!this.customerId) {
        console.log("tryyyy", this.customerId);
        this.x.error = "Please select customer before moving ahead.";
        return false;
      }
      this.processing = true;
      let url = "/assignments/updateJobWithNewCustomer";
      delete this.axios.defaults.headers.common["token"];
      let token = localStorage.getItem(StorageKeys.SessionKey);
      let config = {
        headers: {
          authorization: `bearer ${token}`,
        },
      };

      let body = {
        customerId: this.customerId,
        jobId: this.id,
        // assignmentId: this.ids,
      };
      this.axios
        .post(this.constants.apiUrl + url, body, config)
        .then((response) => {
          this.processing = false;
          this.$eventBus.$emit("refresh-job");
          this.close();
        });

      //this.dialog=true;
    },

    close() {
      // this.$emit("pagination-load", true);
      this.dialog = false;
    },
  },
};
</script>
<style scoped>
.comment__form {
  padding: 11px !important;
}
.message {
  display: inline-block;
  margin: 0 50px;
}
.communication {
  width: 40%;
}
.success {
  font-size: 14px;
  font-weight: 600;
  padding: 5px;
  color: #fff;
}
.v-tabs__slider-wrapper {
  display: none;
}
form .layout.wrap {
  border: 1px solid rgba(26, 54, 126, 0.125) !important;
  border-radius: 15px;
  padding: 30px;
  box-shadow: 0 0.46875rem 2.1875rem rgba(4, 9, 20, 0.03),
    0 0.9375rem 1.40625rem rgba(4, 9, 20, 0.03),
    0 0.25rem 0.53125rem rgba(4, 9, 20, 0.05),
    0 0.125rem 0.1875rem rgba(4, 9, 20, 0.03);
  border-width: 0;
  transition: all 0.2s;
  margin: 20px 0;
}
.comment__form {
  overflow: auto;
}
.p--25 {
  padding: 25px !important;
}
.comment__form[data-v-404971df] {
  padding: 3px 10px !important;
}
.comment__form label.v-label.theme--light {
  font-size: 13px !important;
}
.v-select.v-select--chips .v-select__selections {
  height: 75px;
  overflow: auto;
}
.v-chip--removable .v-chip__content {
  font-size: 11px;
}
.ps__thumb-y {
  top: 0px;
  height: 32px;
}
.error {
  font-size: 14px;
  font-weight: 600;
  padding: 5px;
  color: red;
  background: transparent !important;
}
.blue-button {
  border-radius: 5px;
  background-color: rgb(0, 140, 255) !important;
  color: #ffffff !important;
  border: 2px solid rgb(0, 140, 255) !important;
  padding: 2px 10px;
}
.assign-button {
  border-radius: 5px;
  background-color: rgb(0, 140, 255) !important;
  color: #ffffff !important;
  border: 2px solid rgb(0, 140, 255) !important;
  padding: 2px 2px;
}
.commentbtn {
  position: absolute;
  right: 300px;
  top: 8px;
}
.popup-action-inline {
  align-items: center;
  display: inline-flex !important;
  max-width: max-content;
  pointer-events: none;
  position: relative !important;
  width: auto !important;
  z-index: 5;
}
.popup-action-inline .commentbtn {
  margin: 0 !important;
  margin-right: 0 !important;
  pointer-events: auto;
  position: relative !important;
  right: auto !important;
  top: auto !important;
}
.bg-grey {
  background-color: #bdc3c7;
}
.theme--light.v-chip {
  background: #feebd9 !important;
  color: rgb(248, 159, 69) !important;
}
.tag-input span.chip {
  background-color: #1976d2;
  color: #fff;
  font-size: 1em;
}

.tag-input span.v-chip {
  background-color: #1976d2;
  color: #fff;
  font-size: 1em;
  padding-left: 7px;
}

.tag-input span.v-chip::before {
  content: "label";
  font-family: "Material Icons";
  font-weight: normal;
  font-style: normal;
  font-size: 20px;
  line-height: 1;
  letter-spacing: normal;
  text-transform: none;
  display: inline-block;
  white-space: nowrap;
  word-wrap: normal;
  direction: ltr;

  -webkit-font-smoothing: antialiased;
}
.info {
  padding: 10px;
  font-size: 14px;
  color: #ffffff;
  border-radius: 10px;
}
.scrollbar-hidden {
  -ms-overflow-style: none;
  scrollbar-width: none; /* Firefox */
}

.chat-history {
  height: 180px;
  padding: 4px;
  width: 100%;
  max-width: 100%;
  min-width: 100%;
  display: flex;
  flex-direction: column;
  /* overflow: scroll; */
  overflow-x: hidden;
}
.v-card__title.bg-grey {
  background: #f5f5f5 !important;
  border-bottom: 1px solid #e6e6e6;
}
.bg-gray {
  background: #ebebeb;
}
form .layout.wrap {
  border-radius: 0 px;
  padding: 15 px;
}
.tag-people {
  height: 150px;
  overflow: hidden;
}
.send-layout {
  background: #ffff;
  margin-bottom: 10px;
  padding: 15px;
  border-radius: 10px 0px 0px 10px;
  /* min-width: 320px;
      max-width: 320px; */
  width: 80%;
  float: right;
  margin-right: 11px;
  overflow-wrap: break-word;
}
.received-layout {
  background: white;
  margin-bottom: 10px;
  padding: 15px;
  border-radius: 0px 10px 10px 0px;
  /* min-width: 320px;
      max-width: 320px; */
  width: 100%;
  float: left;
  overflow-wrap: break-word;
}
.flex-tag {
  overflow-y: auto;
  height: 100px;
  max-height: 150px;
}
.tag-orange {
  color: #ea7a1c;
  font-size: 13px;
}
.tag-gray {
  color: #b1abab;
  font-size: 11px;
}
.tag-blue {
  color: #1675f1;
  font-size: 12px;
}
.tag-black {
  color: black;
  font-size: 12px;
}
.gray-dark {
  color: #4d4d4d;
}
.chat-history .row p {
  margin-bottom: 5px;
}
.center {
  text-align: center;
}
.v-autocomplete {
  overflow-x: hidden;
}
.active {
  background-color: #ea7a1c !important;
  color: #ffffff !important;
}
form .layout.wrap {
  padding: 10px 20px !important;
}
.comment__form {
  overflow: auto;
}
.v-card__title span.headline {
  font-size: 17px !important;
  line-height: 20px !important;
  display: inline-block;
}
.chat-history[data-v-404971df] {
  height: 115px;
}
.v-card__title span.headline[data-v-404971df] {
  padding: 0 20px;
}

.oms-job-customer-dialog-card {
  border-radius: 10px !important;
  box-shadow: 0 18px 50px rgba(15, 23, 42, 0.18) !important;
  overflow: hidden;
}

.oms-job-customer-dialog-card .v-card__title {
  align-items: center;
  background: #fff7ed !important;
  border-bottom: 1px solid #fed7aa;
  min-height: 44px;
  padding: 8px 12px !important;
}

.oms-job-customer-dialog-card .v-card__title span.headline {
  color: #172033;
  font-size: 15px !important;
  font-weight: 900;
  padding: 0 !important;
}

.oms-job-customer-dialog-card .comment__form {
  background: #ffffff;
  padding: 12px !important;
}
</style>

<style>
.application .v-dialog.oms-job-dialog.oms-job-dialog--customer.change-customer-dialog {
  max-inline-size: min(28rem, calc(100vw - 2rem)) !important;
  max-width: min(28rem, calc(100vw - 2rem)) !important;
  min-width: min(22rem, calc(100vw - 2rem)) !important;
  width: min(28rem, calc(100vw - 2rem)) !important;
}

.application .v-dialog.change-customer-dialog .oms-job-customer-dialog-card {
  display: flex !important;
  flex-direction: column;
  overflow: hidden;
  width: 100%;
}

.application .v-dialog.change-customer-dialog .change-customer-header {
  align-items: center;
  background: #fff7ed !important;
  border-bottom: 0.0625rem solid #fed7aa;
  display: flex;
  flex: 0 0 auto;
  justify-content: space-between;
  min-height: 3rem;
  padding: 0.75rem 1rem !important;
}

.application .v-dialog.change-customer-dialog .change-customer-title {
  color: #1c2b5f !important;
  font-size: 0.975rem !important;
  font-weight: 800 !important;
  letter-spacing: -0.01em;
  line-height: 1.25;
  margin: 0;
}

.application .v-dialog.change-customer-dialog .change-customer-close {
  height: 1.75rem !important;
  margin: 0 !important;
  width: 1.75rem !important;
}

.application .v-dialog.change-customer-dialog .change-customer-close .v-icon {
  color: #3a382f !important;
  font-size: 1.25rem !important;
}

.application .v-dialog.change-customer-dialog .change-customer-body {
  max-height: none !important;
  overflow: visible !important;
  padding: 1.25rem !important;
}

.application .v-dialog.change-customer-dialog form {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.application .v-dialog.change-customer-dialog .change-customer-field {
  min-width: 0;
  width: 100%;
}

.application .v-dialog.change-customer-dialog .change-customer-label {
  color: #3a382f;
  display: block;
  font-size: 0.75rem;
  font-weight: 800;
  line-height: 1.3;
  margin-bottom: 0.375rem;
}

.application .v-dialog.change-customer-dialog .change-customer-input,
.application .v-dialog.oms-job-dialog--customer .change-customer-input {
  margin: 0 !important;
  padding-top: 0 !important;
  width: 100%;
}

.application .v-dialog.change-customer-dialog .change-customer-input .v-label {
  display: none !important;
}

.application .v-dialog.change-customer-dialog .change-customer-input .v-input__slot::before,
.application .v-dialog.change-customer-dialog .change-customer-input .v-input__slot::after {
  display: none !important;
}

.application .v-dialog.change-customer-dialog .change-customer-input .v-input__slot,
.application .v-dialog.change-customer-dialog .change-customer-input.v-text-field--outline > .v-input__control > .v-input__slot {
  align-items: center;
  background: #ffffff !important;
  border: 0.0625rem solid #e4e1d9 !important;
  border-radius: 0.5rem !important;
  box-shadow: none !important;
  min-height: 2.5rem !important;
  padding: 0 0.75rem !important;
}

.application .v-dialog.change-customer-dialog .change-customer-input.v-input--is-focused .v-input__slot {
  border-color: #ea7a1c !important;
  box-shadow: 0 0 0 0.1875rem rgba(234, 122, 28, 0.12) !important;
}

.application .v-dialog.change-customer-dialog .change-customer-input input,
.application .v-dialog.change-customer-dialog .change-customer-input .v-select__selections,
.application .v-dialog.change-customer-dialog .change-customer-input .v-select__selection {
  color: #3a382f !important;
  font-size: 0.8125rem !important;
  margin: 0 !important;
  overflow: hidden;
  padding: 0 !important;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.application .v-dialog.change-customer-dialog .change-customer-input input::placeholder {
  color: #8a857c !important;
  opacity: 1;
}

.application .v-dialog.change-customer-dialog .change-customer-input .v-input__append-inner {
  align-self: center;
  margin: 0 !important;
}

.application .v-dialog.change-customer-dialog .change-customer-actions {
  display: flex;
  justify-content: flex-end;
}

.application .v-dialog.change-customer-dialog .change-customer-submit.v-btn {
  background: #ea7a1c !important;
  border: 0.0625rem solid #ea7a1c !important;
  border-radius: 0.5rem !important;
  box-shadow: none !important;
  color: #ffffff !important;
  float: none !important;
  font-weight: 800 !important;
  height: 2.25rem !important;
  letter-spacing: 0 !important;
  margin: 0 !important;
  min-width: 8.75rem !important;
  text-transform: none !important;
}

.application .v-dialog.change-customer-dialog .change-customer-submit.v-btn .v-btn__content {
  color: #ffffff !important;
}
</style>
